import { Outlet, RouteObject } from "react-router";
import Klientkontoerklaering from "@/routes/klientkontoerklaering/Klientkontoerklaering";
import IntroKlientkontoerklaering from "@/routes/klientkontoerklaering/IntroKlientkontoerklaering";
import KlientkontoerklaeringTilsvar from "@/components/klientkontoerklaering/KlientkontoerklaeringTilsvar";
import KlientkontoerklaeringIntetTilsvar from "@/components/klientkontoerklaering/KlientkontoerklaeringIntetTilsvar";
import { klientkontoerklaeringIdLoader } from "@/routes/klientkontoerklaering/KlientkontoerklaeringById";
import PageError from "@/routes/PageError";
import { ROUTES } from "@/constants/routes";

export const klientkontoRoutes: RouteObject[] = [
  {
    path: "/klientkontoerklaering",
    element: <Klientkontoerklaering />,
    children: [
      {
        path: "/klientkontoerklaering/:id",
        element: <Outlet />,
        loader: klientkontoerklaeringIdLoader,
        id: ROUTES.klientkonto.id,
        children: [
          {
            path: "/klientkontoerklaering/:id",
            element: <IntroKlientkontoerklaering />,
          },
          {
            path: "/klientkontoerklaering/:id/tilsvar",
            element: (
              <KlientkontoerklaeringTilsvar
                loaderRouteId={ROUTES.klientkonto.id}
                formularType="Formular1"
              />
            ),
            id: ROUTES.klientkontoTilsvar.id,
            errorElement: <PageError msg="Erklæring findes ikke" />,
          },
          {
            path: "/klientkontoerklaering/:id/intet-tilsvar",
            element: (
              <KlientkontoerklaeringIntetTilsvar
                loaderRouteId={ROUTES.klientkonto.id}
              />
            ),
            id: ROUTES.klientkontoIntetTilsvar.id,
            errorElement: <PageError msg="Erklæring findes ikke" />,
          },
        ],
      },
    ],
  },
];
